import {
  AdvancedFilterDataSchema,
  FilterGroupSchema,
} from "@redotech/redo-model/views/views";
import * as z from "zod/v4";

const ProductImage_ = z.object({ url: z.string(), kind: z.string() });
export const ProductImage: z.ZodType<ProductImage> = ProductImage_;
export interface ProductImage extends z.infer<typeof ProductImage_> {}

const StationQueueItem_ = z.object({
  batchId: z.string(),
  flowId: z.string(),
  flowName: z.string().nullable(),
  triggerKind: z.string().nullable(),
  title: z.string().nullable(),
  // Aggregate counts
  workOrderCount: z.number().int(),
  notStartedCount: z.number().int(),
  inProgressCount: z.number().int(),
  completedCount: z.number().int(),
  // Batch status derived from member WOs
  status: z.string(),
  productImages: z.array(ProductImage),
  createdAt: z.date(),
  // Active pick session for this batch (if any)
  sessionId: z.string().nullable(),
  // Totes currently assigned to work orders in this batch
  toteNames: z.array(z.string()),
  // Total quantity across all WOs in the batch
  totalQuantity: z.number().int(),
  // Earliest barcode_printed_at across WOs in this batch (null if none printed)
  barcodePrintedAt: z.date().nullable(),
});
export const StationQueueItem: z.ZodType<StationQueueItem> = StationQueueItem_;
export interface StationQueueItem extends z.infer<typeof StationQueueItem_> {}

export const getStationQueue = {
  name: "getStationQueue" as const,
  input: z.object({
    stationId: z.string().optional(),
    sort: z
      .object({ key: z.string(), direction: z.enum(["asc", "desc"]) })
      .optional(),
    search: z.string().nullish(),
    filterGroup: FilterGroupSchema.nullish(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).default([]),
  }),
  output: z.object({ items: z.array(StationQueueItem) }),
};
